import { ButtonAndDescription } from "../components/TSLandingPage";

export const prmgProdExecutiveLiveboards: ButtonAndDescription[] = [
  {
    title: "AM Wholesale Report",
    description: "",
    link: "pinboard/1711b5fa-3822-4946-b87a-ea7574e9f3b0",
  },
  {
    title: "Executive Dashboard",
    description: "",
    link: "pinboard/63eceeb6-2df7-4fe9-9f9b-afd08555cd4b",
  },
  {
    title: "Processing Metrics",
    description: "",
    link: "pinboard/35c591c5-141b-4246-bce5-e50a5a0649d1",
  },
  {
    title: "UW Metrics",
    description: "",
    link: "pinboard/a5419de1-52c8-45cb-be77-f2585e11f9ea",
  },
  {
    title: "Leakage Ops Report",
    description: "",
    link: "pinboard/0596fe93-fb24-432b-b0a2-ff9a7781f4ed",
  },
  {
    title: "UW Vendor Metrics",
    description: "",
    link: "pinboard/57495ad4-dd22-4413-afe3-2c31345d36fc",
  },
  {
    title: "Executive Retail Stats MTD",
    description: "",
    link: "pinboard/9643af96-d335-4672-ac90-416adb37b48e",
  },
  {
    title: "Branch Code Information",
    description: "",
    link: "pinboard/6ee104e1-99d7-4441-9e6d-f6de079a18c2",
  },
  {
    title: "UW Stats",
    description: "",
    link: "pinboard/288b3e13-97bb-4fa5-ae50-a7b8067a9370",
  },
  {
    title: "Loan Processor Report",
    description: "",
    link: "pinboard/aac2907a-6f4e-4664-83b4-5b8008e6b52f",
  },
  {
    title: "Historical Data",
    description: "",
    link: "pinboard/1e0d1f64-d733-4f72-8abb-44a1e4d803d0",
  },
  {
    title: "Loan Pull-Through",
    description: "",
    link: "pinboard/c6051f3c-561b-49e9-824e-8554e73f692a",
  },
  {
    title: "Doc Drawer Report",
    description: "",
    link: "pinboard/dcdd1d91-21f7-4f52-a617-806649f26120",
  },
  {
    title: "State Warehouse Audit Report",
    description: "",
    link: "pinboard/8edfe7eb-9bbb-47de-8b99-62593c2f7dbd",
  },
  {
    title: "TBD Pull Through",
    description: "",
    link: "pinboard/9be5e6c8-5892-4a09-85fe-bcde0cba3052",
  },
  {
    title: "UW Turn Times",
    description: "",
    link: "pinboard/ec947278-0200-4247-8fde-7007bf8a2258",
  },
  {
    title: "Closing Turn Times",
    description: "",
    link: "pinboard/b1a1565e-5363-4259-81c9-98eda9c6460f",
  },
  {
    title: "Payroll AE/RM Loan Pull Through",
    description: "",
    link: "pinboard/be4042cf-863f-4205-8e7a-6bb441b211b7",
  },
  {
    title: "Non-QM Production",
    description: "",
    link: "pinboard/9a89ba27-5d14-4f74-a5e7-54f3e3501105",
  },
  {
    title: "Usage Report",
    description: "",
    link: "pinboard/95e14db3-365e-4e83-946c-61e979bc67c1",
  },
  {
    title: "Previous Week Fulfillment Center Report",
    description: "",
    link: "pinboard/1faa3771-6033-4782-9476-eb34cc65d4e1",
  },
  {
    title: "Executive Data Comparison",
    description: "",
    link: "pinboard/bd45f42a-19c7-4133-b85c-d9ef1e58ecd7",
  },
  {
    title: "Processor Role Report",
    description: "",
    link: "pinboard/8cc84498-2ef0-45b0-9307-03ed92854385",
  },
  {
    title: "Argyle Reporting",
    description: "",
    link: "pinboard/02c195d0-ef9c-4185-b3b1-206a41840f60",
  },
  {
    title: "UW Scorecard",
    description: "",
    link: "pinboard/b8cb3520-b56d-45e4-ba5d-85d75fbb6269",
  },
  {
    title: "Retail: Loan Source",
    description: "",
    link: "pinboard/e71cf288-8d9a-4754-ad92-31a3e0a8e822",
  },
  {
    title: "DPA Analysis",
    description: "",
    link: "pinboard/473125bd-8722-4155-bd20-6cd2ffde8cce",
  },
];

export const prmgProdOperationsLiveboards: ButtonAndDescription[] = [
  {
    title: "AM Funded Stats",
    description: "",
    link: "pinboard/c822e825-3400-445b-8bcb-3004a4753151",
  },
  {
    title: "Post Closing Shipping Report",
    description: "",
    link: "pinboard/4f5f1ea6-2e2b-4e54-8af6-b22051a784e5",
  },
  {
    title: "Loan Pull-Through",
    description: "",
    link: "pinboard/c6051f3c-561b-49e9-824e-8554e73f692a",
  },
  {
    title: "UW Stats",
    description: "",
    link: "pinboard/288b3e13-97bb-4fa5-ae50-a7b8067a9370",
  },
  {
    title: "Doc Drawer Stats",
    description: "",
    link: "pinboard/50323ebc-10de-415a-b04e-6c5557f98ef1",
  },
  {
    title: "Branch Code Information",
    description: "",
    link: "pinboard/6ee104e1-99d7-4441-9e6d-f6de079a18c2",
  },
  {
    title: "Funder Stats",
    description: "",
    link: "pinboard/a596a179-f7ad-4a1d-b47b-f7f460701909",
  },
  {
    title: "UW Turn Times",
    description: "",
    link: "pinboard/ec947278-0200-4247-8fde-7007bf8a2258",
  },
  {
    title: "Loan Submissions",
    description: "",
    link: "pinboard/15dde2bc-cbc7-4191-bb20-c11398ea0d1b",
  },
  {
    title: "SetUp Registration",
    description: "",
    link: "pinboard/2613020a-9175-45d9-b929-2b2904295769",
  },
  {
    title: "CD Drawer Stats",
    description: "",
    link: "pinboard/9ae98bb8-68bb-40b7-8e93-953cb25e6a71",
  },
  {
    title: "Investor Aging FC Escalation Report",
    description: "",
    link: "pinboard/2953d849-1275-4bd9-9486-9e030501f9f5",
  },
  {
    title: "PCCD Report",
    description: "",
    link: "pinboard/adf45573-f614-4399-8edb-47798001a436",
  },
  {
    title: "TBD Pull Through",
    description: "",
    link: "pinboard/9be5e6c8-5892-4a09-85fe-bcde0cba3052",
  },
  {
    title: "Leakage Ops Report",
    description: "",
    link: "pinboard/0596fe93-fb24-432b-b0a2-ff9a7781f4ed",
  },
  {
    title: "Account Manager Pipeline Details",
    description: "",
    link: "pinboard/46bda50e-138e-4945-a666-4bbe350181c4",
  },
  {
    title: "Closing Turn Times",
    description: "",
    link: "pinboard/b1a1565e-5363-4259-81c9-98eda9c6460f",
  },
  {
    title: "CD Drawer Vendor",
    description: "",
    link: "pinboard/9fe19502-b4ae-4323-8108-e781baec4d43",
  },
  {
    title: "Previous Week Fulfillment Center Report",
    description: "",
    link: "pinboard/1faa3771-6033-4782-9476-eb34cc65d4e1",
  },
  {
    title: "Operations Pull-Through",
    description: "",
    link: "pinboard/6f16ffe6-74ae-44db-8570-951d199e23e8",
  },
  {
    title: "Outsourced Underwriting Monthly Report",
    description: "",
    link: "pinboard/7bfdeb7f-7646-4479-b00c-ef0c3f8e59d3",
  },
  {
    title: "Suspense Report",
    description: "",
    link: "pinboard/e6f1b721-f47d-41ab-ba7d-7556ac4e9d1a",
  },
  {
    title: "Resubmission Report",
    description: "",
    link: "pinboard/7300f220-5916-456e-8cb5-d2816d2b1cfb",
  },
];

export const prmgProdRetailLiveboards: ButtonAndDescription[] = [
  {
    title: "Loan Pull-Through - Retail",
    description: "",
    link: "pinboard/e549b774-3e72-42f7-ad46-f74b111711fb",
  },
  {
    title: "UW Turn Times",
    description: "",
    link: "pinboard/ec947278-0200-4247-8fde-7007bf8a2258",
  },
  {
    title: "AFS Dashboard",
    description: "",
    link: "pinboard/cf72e436-5e2a-49fc-b1ae-ea4c4d7cf3f4",
  },
  {
    title: "Regional Manager Leaderboard",
    description: "",
    link: "pinboard/02e25a30-a061-46cb-bf20-3929042daf1f",
  },
  {
    title: "Branch Code Information",
    description: "",
    link: "pinboard/6ee104e1-99d7-4441-9e6d-f6de079a18c2",
  },
  {
    title: "Leader Board",
    description: "",
    link: "pinboard/52dbf268-8701-44cd-ba42-7d64e6070553",
  },
  {
    title: "Retail MTD Stats",
    description: "",
    link: "pinboard/820b9fcb-9158-4b05-af76-46ead6be96d8",
  },
  {
    title: "Branch Manager Dashboard",
    description: "",
    link: "pinboard/bc574330-2876-4c8f-b4ac-aee6e95b0251",
  },
  {
    title: "TBD Pull Through - Retail",
    description: "",
    link: "pinboard/5c554a1a-e5a0-4c5e-894e-bedffbfa93a2",
  },
  {
    title: "Pipeline View - Retail",
    description: "",
    link: "pinboard/d2ad0e67-337f-4b0a-83a8-37b5c8ecd6b7",
  },
  {
    title: "Retail Performance Metrics",
    description: "",
    link: "pinboard/c71799a2-efff-49ea-826e-686c9f35ea44",
  },
  {
    title: "Retail Loan Pull-Through",
    description: "",
    link: "pinboard/ef25c13a-b1ef-4f83-8e66-f0741efb4d96",
  },
  {
    title: "Closing Turn Times",
    description: "",
    link: "pinboard/b1a1565e-5363-4259-81c9-98eda9c6460f",
  },
  {
    title: "Loan Processor Stats",
    description: "",
    link: "pinboard/40b7145a-6637-44d6-aa32-421c3c9a437d",
  },
  {
    title: "Britt's Blend Data Bible",
    description: "",
    link: "pinboard/02bde33c-3be7-4c37-87db-1e33c279f106",
  },
  {
    title: "Retail Data Comparison",
    description: "",
    link: "pinboard/e8080f30-129a-4f24-904c-58d2c44a304a",
  },
  {
    title: "Retail Scorecard",
    description: "",
    link: "pinboard/402b5f3f-3ab1-4688-a3db-82467b84f257",
  },
  {
    title: "Retail Prior Month Stats",
    description: "",
    link: "pinboard/c8f83e27-16bf-45a7-92a7-61696f5eb6db",
  },
];

export const prmgProdWholesaleLiveboards: ButtonAndDescription[] = [
  {
    title: "Pipeline View - Wholesale",
    description: "",
    link: "pinboard/55a0a1a5-4ff2-43fe-913a-ce3fc7592723",
  },
  {
    title: "AE Scorecard",
    description: "",
    link: "pinboard/45f4377c-457f-4d6b-b7b0-eeb06cea6ef8",
  },
  {
    title: "Wholesale - Correspondent Stats MTD",
    description: "",
    link: "pinboard/64d723ac-2414-47fe-9430-f1a34cf47dad",
  },
  {
    title: "Wholesale - Correspondent Stats",
    description: "",
    link: "pinboard/c38dc596-2c02-47d6-85c1-19028054ceb5",
  },
  {
    title: "Wholesale - Correspondent Lock Expiration",
    description: "",
    link: "pinboard/9519e3c5-3a67-4a77-9be0-a3c171855b51",
  },
  {
    title: "UW Turn Times",
    description: "",
    link: "pinboard/ec947278-0200-4247-8fde-7007bf8a2258",
  },
  {
    title: "Wholesale - Correspondent Pipeline View",
    description: "",
    link: "pinboard/30324452-c190-47c2-9758-914c3c963965",
  },
  {
    title: "Branch Code Information",
    description: "",
    link: "pinboard/6ee104e1-99d7-4441-9e6d-f6de079a18c2",
  },
  {
    title: "Wholesale - Correspondent Dashboard",
    description: "",
    link: "pinboard/2abb54ee-af16-4775-a83b-f4c1e598503f",
  },
  {
    title: "Wholesale - Correspondent Data for Projections",
    description: "",
    link: "pinboard/46187440-19bd-47ae-a865-f55bbf392571",
  },
  {
    title: "Wholesale TBD Pull-Through Report",
    description: "",
    link: "pinboard/dbbcdbdc-3f0b-4451-adba-96d320a5a31f",
  },
  {
    title: "Wholesale - Correspondent Potential Fundings",
    description: "",
    link: "pinboard/f7706944-5a60-4ed4-8cc8-07a98fc6f84f",
  },
  {
    title: "Wholesale - Correspondent Loan Pull-Through",
    description: "",
    link: "pinboard/81586501-d791-469f-bbc7-de67d96f7498",
  },
  {
    title: "Wholesale - Correspondent AE Pipeline Details",
    description: "",
    link: "pinboard/e214f088-faa4-492a-bd19-8c628eaf9d7f",
  },
  {
    title: "Wholesale - Correspondent Combined AE/TPO STATS",
    description: "",
    link: "pinboard/24bedf9c-8023-4053-be1f-7714f56133bc",
  },
  {
    title: "Wholesale - Correspondent Sales Comments",
    description: "",
    link: "pinboard/c8f72a6b-1326-48dd-878a-cf25d4695f7b",
  },
  {
    title: "Wholesale TPO Scorecard",
    description: "",
    link: "pinboard/b5544cec-93f0-4e65-be30-0964c3b4296e",
  },
  {
    title: "Correspondent TPO Scorecard",
    description: "",
    link: "pinboard/7e852b99-b92a-452d-a029-8429db3aa178",
  },
  {
    title: "TPO Pricing",
    description: "",
    link: "pinboard/7c405506-8bac-4bf6-bc76-14bd0eb62de8",
  },
  {
    title: "Wholesale STATS MTD",
    description: "",
    link: "pinboard/ecbd6901-0703-4392-9e79-ed422dc0ab53",
  },
  {
    title: "IQ Broker Optimization",
    description: "",
    link: "pinboard/2503b0c7-55bd-4b5a-ba1f-580609b12f63",
  },
  {
    title: "TBD Pull Through Report",
    description: "",
    link: "pinboard/3895514e-412c-438d-9c16-975057d446ed",
  },
  {
    title: "Closing Turn Times",
    description: "",
    link: "pinboard/b1a1565e-5363-4259-81c9-98eda9c6460f",
  },
  {
    title: "Correspondent Data Comparison",
    description: "",
    link: "pinboard/ca132375-23e6-423f-bf02-26ab075867c8",
  },
  {
    title: "Wholesale Data Comparison",
    description: "",
    link: "pinboard/b4c3c55d-a8ca-45cd-bb17-b5f4fd06bef3",
  },
  {
    title: "Heat Map",
    description: "",
    link: "pinboard/f4083b8d-b5be-4e37-8550-0dd748503498",
  },
  {
    title: "Wholesale - Correspondent Lock Pull-Through",
    description: "",
    link: "pinboard/83212acf-f139-4f0e-8bba-8bf88644ad2c",
  },
  {
    title: "Wholesale - Correspondent Pricing Concessions",
    description: "",
    link: "pinboard/6bf74b8e-4420-4f2c-ad2e-c6aaf4965c3f",
  },
];

export const prmgProdAdminLiveboards: ButtonAndDescription[] = [
  {
    title: "Wholesale Pull Through 90 Days Look Back",
    description: "",
    link: "pinboard/be0c664d-4097-4e76-99d4-1ae31777fa98",
  },
];

export const prmgUATExecutiveLiveboards: ButtonAndDescription[] = [
  {
    title: "Executive Dashboard_UAT",
    description: "",
    link: "pinboard/de99d132-7b28-4fff-8bc0-46125ee21091",
  },
  {
    title: "UW Vendor Metrics_UAT",
    description: "",
    link: "pinboard/209f8535-06b2-4c1a-a673-49b466d6f47a",
  },
  {
    title: "AM Wholesale Report_UAT",
    description: "",
    link: "pinboard/937bbb74-254e-425f-8732-99011df319c4",
  },
  {
    title: "Leakage Ops Report_UAT",
    description: "",
    link: "pinboard/63ba6082-94f5-4c6e-b011-106a7e4f7d33",
  },
  {
    title: "Processing Metrics_UAT",
    description: "",
    link: "pinboard/639dcef4-c9b2-42c8-b039-15d8fae52594",
  },
  {
    title: "Branch Code Information_UAT",
    description: "",
    link: "pinboard/3eb13a02-b476-4806-86bd-ddcebbd2055e",
  },
  {
    title: "UW Metrics_UAT",
    description: "",
    link: "pinboard/a4abe299-6772-428b-89fd-f430a579f4c2",
  },
  {
    title: "Executive Retail Stats MTD_UAT",
    description: "",
    link: "pinboard/5eb5b7d3-de90-4d87-a1b1-6fe7a7c24a9c",
  },
  {
    title: "Loan Processor Report_UAT",
    description: "",
    link: "pinboard/be535cdb-1495-47f6-a77b-86dbd9cc8819",
  },
  {
    title: "UW Stats_UAT",
    description: "",
    link: "pinboard/62f3c346-bb9f-434a-8c07-7ccbd79651a3",
  },
  {
    title: "Doc Drawer Report_UAT",
    description: "",
    link: "pinboard/5928af7e-3012-4193-903f-2c6bd4b26d28",
  },
  {
    title: "Loan Pull-Through_UAT",
    description: "",
    link: "pinboard/9d903f22-6bb7-44f1-9da4-62349541a2a9",
  },
  {
    title: "Historical Data_UAT",
    description: "",
    link: "pinboard/249abc71-5f81-4eea-b04f-4700c3c3288d",
  },
  {
    title: "TBD Pull Through_UAT",
    description: "",
    link: "pinboard/bbb06cd7-b46e-4ea5-9f43-de3241484541",
  },
  {
    title: "UW Turn Times_UAT",
    description: "",
    link: "pinboard/4fa9c873-2a03-4b2a-993f-b151e4b04feb",
  },
  {
    title: "State Warehouse Audit Report_UAT",
    description: "",
    link: "pinboard/b863c585-3280-4233-8069-72b96acfbb77",
  },
  {
    title: "Non-QM Production_UAT",
    description: "",
    link: "pinboard/b102e51e-6a13-49a1-97b0-8909ffb04eb2",
  },
  {
    title: "Payroll AE/RM Loan Pull Through_UAT",
    description: "",
    link: "pinboard/f4bf3d2f-762d-4236-b725-accce54c6806",
  },
  {
    title: "Closing Turn Times_UAT",
    description: "",
    link: "pinboard/27405320-bf92-4600-b631-2381e45afe67",
  },
  {
    title: "Previous Week Fullfilment Center Report_UAT",
    description: "",
    link: "pinboard/c9ca8c9b-d65b-45d0-8414-69eb167e1576",
  },
  {
    title: "Executive Data Comparison_UAT",
    description: "",
    link: "pinboard/8589aef4-632f-4432-b994-65daceb87808",
  },
  {
    title: "UW Scorecard_UAT",
    description: "",
    link: "pinboard/75352dda-f38a-491b-bf1f-1bdc61e18d5f",
  },
  {
    title: "Processor Role Report_UAT",
    description: "",
    link: "pinboard/336ba212-ba55-409d-a8dc-dd1c4496d64d",
  },
  {
    title: "Argyle Reporting_UAT",
    description: "",
    link: "pinboard/67aecb8d-abf8-4146-839c-ccaf74bdfa37",
  },
  {
    title: "Retail: Loan Source_UAT",
    description: "",
    link: "pinboard/4637fad9-6020-43bb-8278-f589a9a33919",
  },
  {
    title: "DPA Analysis_UAT",
    description: "",
    link: "pinboard/932df29f-f70a-436a-b2bd-b90e7c4a1efe",
  },
];

export const prmgUATOperationsLiveboards: ButtonAndDescription[] = [
  {
    title: "Branch Code Information_UAT",
    description: "",
    link: "pinboard/3eb13a02-b476-4806-86bd-ddcebbd2055e",
  },
  {
    title: "Loan Pull-Through_UAT",
    description: "",
    link: "pinboard/9d903f22-6bb7-44f1-9da4-62349541a2a9",
  },
  {
    title: "UW Stats_UAT",
    description: "",
    link: "pinboard/62f3c346-bb9f-434a-8c07-7ccbd79651a3",
  },
  {
    title: "AM Funded Stats_UAT",
    description: "",
    link: "pinboard/9b9daeef-5334-48ef-b980-58a43e74c53c",
  },
  {
    title: "Post Closing Shipping Report_UAT",
    description: "",
    link: "pinboard/9abb8751-feb9-45a9-8775-4dc35cb586b0",
  },
  {
    title: "Doc Drawer Stats_UAT",
    description: "",
    link: "pinboard/50921a32-ae65-4fcd-b5a1-ba5f9faed600",
  },
  {
    title: "Loan Submissions_UAT",
    description: "",
    link: "pinboard/33a27611-6317-4642-a66d-381f868e6782",
  },
  {
    title: "Funder Stats_UAT",
    description: "",
    link: "pinboard/edc66a11-3838-43a1-94d7-ccb9871c7899",
  },
  {
    title: "SetUp Registration_UAT",
    description: "",
    link: "pinboard/39908653-f075-4d20-9b23-bf18f39bc6f3",
  },
  {
    title: "UW Turn Times_UAT",
    description: "",
    link: "pinboard/4fa9c873-2a03-4b2a-993f-b151e4b04feb",
  },
  {
    title: "Investor Aging FC Escalation Report_UAT",
    description: "",
    link: "pinboard/e02025c4-433e-4e62-9219-d3d2a717eaf1",
  },
  {
    title: "CD Drawer Stats_UAT",
    description: "",
    link: "pinboard/b3338b4d-5fd4-4413-a1ff-f2c11a26bfdd",
  },
  {
    title: "Account Manager Pipeline Details_UAT",
    description: "",
    link: "pinboard/f6dc388a-a10f-4a10-ab31-74ce74112775",
  },
  {
    title: "PCCD Report_UAT",
    description: "",
    link: "pinboard/aa22fbee-b662-4819-ab01-91d866c31d08",
  },
  {
    title: "TBD Pull Through_UAT",
    description: "",
    link: "pinboard/bbb06cd7-b46e-4ea5-9f43-de3241484541",
  },
  {
    title: "Leakage Ops Report_UAT",
    description: "",
    link: "pinboard/63ba6082-94f5-4c6e-b011-106a7e4f7d33",
  },
  {
    title: "CD Drawer Vendor_UAT",
    description: "",
    link: "pinboard/08c27a9d-cc89-48ea-939e-1910af404b9f",
  },
  {
    title: "Closing Turn Times_UAT",
    description: "",
    link: "pinboard/27405320-bf92-4600-b631-2381e45afe67",
  },
  {
    title: "Previous Week Fulfillment Center Report_UAT",
    description: "",
    link: "pinboard/c9ca8c9b-d65b-45d0-8414-69eb167e1576",
  },
  {
    title: "Operations Pull-Through_UAT",
    description: "",
    link: "pinboard/cc3a32a1-1edc-4bb2-9342-0fb372f610ed",
  },
  {
    title: "Outsourced Underwriting Monthly Report_UAT",
    description: "",
    link: "pinboard/d2cb48d3-273e-4077-a721-4dd247eaef85",
  },
  {
    title: "Suspense Report_UAT",
    description: "",
    link: "pinboard/8fd61a12-a8a2-4381-b471-099cace06efa",
  },
  {
    title: "Resubmission Report_UAT",
    description: "",
    link: "pinboard/73bad842-9d09-4f8e-8856-23f65fa8940c",
  },
];

export const prmgUATRetailLiveboards: ButtonAndDescription[] = [
  {
    title: "AFS Dashboard_UAT",
    description: "",
    link: "pinboard/798647e5-435d-42f8-bc63-236ebbd304e0",
  },
  {
    title: "Loan Pull-Through - Retail_UAT",
    description: "",
    link: "pinboard/cc37497b-e825-4b48-b884-e497ba43b956",
  },
  {
    title: "Branch Code Information_UAT",
    description: "",
    link: "pinboard/3eb13a02-b476-4806-86bd-ddcebbd2055e",
  },
  {
    title: "Regional Manager Leaderboard_UAT",
    description: "",
    link: "pinboard/923c94c1-a31e-479b-8391-8357aed18299",
  },
  {
    title: "UW Turn Times_UAT",
    description: "",
    link: "pinboard/4fa9c873-2a03-4b2a-993f-b151e4b04feb",
  },
  {
    title: "Retail MTD Stats_UAT",
    description: "",
    link: "pinboard/61ce497c-d8ef-4f7c-be83-0adcb844189e",
  },
  {
    title: "Leader Board_UAT",
    description: "",
    link: "pinboard/e729999b-947a-435b-b56a-1e37d51c7480",
  },
  {
    title: "Branch Manager Dashboard_UAT",
    description: "",
    link: "pinboard/67916c01-55cc-4bbf-b4e2-6a8c5bc1d1a4",
  },
  {
    title: "Pipeline View - Retail_UAT",
    description: "",
    link: "pinboard/27991ad5-ae7d-489b-b983-4fbea2d4eeba",
  },
  {
    title: "TBD Pull Through - Retail_UAT",
    description: "",
    link: "pinboard/a7c66e99-a095-4f1d-9a87-4fd0a06e4f36",
  },
  {
    title: "Retail Performance Metrics_UAT",
    description: "",
    link: "pinboard/aaeb6b5a-7fee-4f18-a0a6-f36fc2e387a2",
  },
  {
    title: "Closing Turn Times_UAT",
    description: "",
    link: "pinboard/27405320-bf92-4600-b631-2381e45afe67",
  },
  {
    title: "Retail Loan Pull-Through_UAT",
    description: "",
    link: "pinboard/927b968c-85a1-45cd-be93-c9e7b55c1d77",
  },
  {
    title: "Loan Processor Stats_UAT",
    description: "",
    link: "pinboard/7290f564-0918-4948-b8d1-a8a1350acdaf",
  },
  {
    title: "Britt's Blend Data Bible",
    description: "",
    link: "pinboard/4db5a8e3-9079-4f0f-8ef6-3791350c226b",
  },
  {
    title: "Retail Data Comparison_UAT",
    description: "",
    link: "pinboard/a733e193-fd96-4b7d-a7cd-b7f3bb10b0b8",
  },
  {
    title: "Retail Scorecard_UAT",
    description: "",
    link: "pinboard/72c0aa8e-a0c0-4ad4-ac15-395963f44902",
  },
  {
    title: "Retail Prior Month Stats_UAT",
    description: "",
    link: "pinboard/f33eebd3-19a5-4218-af2b-605e370f33e7",
  },
];

export const prmgUATWholesaleLiveboards: ButtonAndDescription[] = [
  {
    title: "Pull Through Report_UAT",
    description: "",
    link: "pinboard/1b522001-ebb6-4bce-acb3-c8cd27f3888f",
  },
  {
    title: "Pipeline View - Wholesale_UAT",
    description: "",
    link: "pinboard/ed2d5ae7-cc6f-4da4-ae65-1c4216475729",
  },
  {
    title: "AE Scorecard_UAT",
    description: "",
    link: "pinboard/831b46d7-5af2-4f3a-845f-7479e3f526c4",
  },
  {
    title: "Wholesale - Correspondent Dashboard_UAT",
    description: "",
    link: "pinboard/57947353-17f0-4e31-ad4c-b50c3e2be90e",
  },
  {
    title: "Branch Code Information_UAT",
    description: "",
    link: "pinboard/3eb13a02-b476-4806-86bd-ddcebbd2055e",
  },
  {
    title: "Wholesale - Correspondent Potential Fundings_UAT",
    description: "",
    link: "pinboard/9a1a01a8-3be1-4e25-9472-a5e4c2ae3e84",
  },
  {
    title: "Wholesale - Correspondent Lock Expiration_UAT",
    description: "",
    link: "pinboard/a4498a6b-294e-4eee-bae0-853470c177ce",
  },
  {
    title: "Wholesale - Correspondent Stats MTD_UAT",
    description: "",
    link: "pinboard/3bd6ba9e-d7e5-4cc8-8577-9b6841f8bc60",
  },
  {
    title: "TBD Pull Through_UAT",
    description: "",
    link: "pinboard/bbb06cd7-b46e-4ea5-9f43-de3241484541",
  },
  {
    title: "Wholesale - Correspondent Stats_UAT",
    description: "",
    link: "pinboard/53613f2c-da5a-4bab-aca0-b50c33bc67b2",
  },
  {
    title: "UW Turn Times_UAT",
    description: "",
    link: "pinboard/4fa9c873-2a03-4b2a-993f-b151e4b04feb",
  },
  {
    title: "Wholesale - Correspondent Pipeline View_UAT",
    description: "",
    link: "pinboard/e6d842fd-0bbe-463d-9e53-8f4d94004d88",
  },
  {
    title: "Wholesale - Correspondent Data for Projections_UAT",
    description: "",
    link: "pinboard/ca0e4945-a487-4576-bd1c-552168a67512",
  },
  {
    title: "Wholesale - Correspondent AE Pipeline Details_UAT",
    description: "",
    link: "pinboard/582f663c-6fe0-4b13-87cc-66823696f7fd",
  },
  {
    title: "Wholesale TBD Pull-Through Report_UAT",
    description: "",
    link: "pinboard/9f878940-9e45-4b45-9f75-22d5e356bb14",
  },
  {
    title: "Wholesale - Correspondent Loan Pull-Through_UAT",
    description: "",
    link: "pinboard/daf2bd9b-3320-4817-8fba-f31add8c0b4d",
  },
  {
    title: "Wholesale TPO Scorecard_UAT",
    description: "",
    link: "pinboard/cb6f905c-c37e-4cb6-86b2-b3640f8df5a7",
  },
  {
    title: "Wholesale - Correspondent Comb. AE/TPO STATS_UAT",
    description: "",
    link: "pinboard/176e0411-e1c4-4054-82a0-fd4d8252c54e",
  },
  {
    title: "Correspondent TPO Scorecard_UAT",
    description: "",
    link: "pinboard/72ab5ff2-94c9-4672-8e48-dce22a91e8c9",
  },
  {
    title: "IQ Broker Optimization_UAT",
    description: "",
    link: "pinboard/aaa6ddf8-5356-46b4-a5f4-a8d16677b881",
  },
  {
    title: "TPO Pricing_UAT",
    description: "",
    link: "pinboard/93dbca75-9be9-43f7-86dd-9006cc6f3b4f",
  },
  {
    title: "Wholesale - Correspondent Sales Comments_UAT",
    description: "",
    link: "pinboard/62cc5995-d1bc-4729-ae91-c97d00a65117",
  },
  {
    title: "Wholesale STATS MTD_UAT",
    description: "",
    link: "pinboard/f46673a5-4512-484f-8041-1df16da18de3",
  },
  {
    title: "Closing Turn Times_UAT",
    description: "",
    link: "pinboard/27405320-bf92-4600-b631-2381e45afe67",
  },
  {
    title: "Correspondent Data Comparison_UAT",
    description: "",
    link: "pinboard/3141be3f-e1cf-4a82-a61e-5986a7a02935",
  },
  {
    title: "Wholesale Data Comparison_UAT",
    description: "",
    link: "pinboard/aa5d3454-1c84-47cb-b243-b28275175826",
  },
  {
    title: "Heat Map_UAT",
    description: "",
    link: "pinboard/5d3e7dfc-1c3a-46e4-8818-271a2afd712b",
  },
  {
    title: "Wholesale - Correspondent Lock Pull-Through_UAT",
    description: "",
    link: "pinboard/b3edf305-ccc9-46b4-9e44-670306adef83",
  },
  {
    title: "Wholesale - Correspondent Pricing Concessions_UAT",
    description: "",
    link: "pinboard/82c78269-bf01-464c-8624-eba1c4270ec1",
  },
];

export const prmgUATAdminLiveboards: ButtonAndDescription[] = [
  {
    title: "Wholesale Pull Through 90 Days Look Back_UAT",
    description: "",
    link: "pinboard/d902312f-164f-42ee-90a5-0c27d572e866",
  },
];
